/**
*  Date    : 2022/09/21
*  Author  : Liuzijun
*  Declare : member
*/
import Immutable from 'seamless-immutable';

import combinedMarketing from '@/api/combinedMarketing';
import digital from '@/api/digital';
import exercisebook from '@/api/exercisebook';

export default {
  namespace: 'member',
  state: Immutable({
    isWhutAlumni: false, // 是否理工校友
    initialCharge: false, // 是否为首购系统会员包
    isByPurchase: false, // 是否显示会员包购买提示气泡
    // 小睿伴学h5会员 最后来源书
    latestBook: {}
  }),
  reducers: {
    update: (state, { data, field }) => {
      return state.merge({ [field]: data });
    },
    updateInitialCharge: (state, { data, field }) => {
      return state.merge({ [field]: !data });
    }
  },
  actions: {
    checkWhutAlumni(data) {
      return {
        type: 'member/update',
        field: 'isWhutAlumni',
        promise: exercisebook.checkWhutAlumni(data)
      };
    },
    getUserBuyCount: () => {
      return {
        type: 'member/updateInitialCharge',
        promise: combinedMarketing.getUserBuyCount(),
        field: 'initialCharge'
      };
    },
    updateByPurchase: data => ({
      type: 'member/update',
      data,
      field: 'isByPurchase'
    }),
    getUserLatestBook: data => ({
      type: 'member/update',
      promise: digital.getUserLatestBook(data),
      field: 'latestBook'
    })

  }
};